<template>
	<div class="job-add">
		<div class="breadcrumb">
			<a-breadcrumb>
				<a-breadcrumb-item>
					<router-link to="/home">首页</router-link>
				</a-breadcrumb-item>
				<a-breadcrumb-item>
					<router-link to="/job">作业管理</router-link>
				</a-breadcrumb-item>
				<a-breadcrumb-item v-if='flowId==null'>执行作业</a-breadcrumb-item>
				<a-breadcrumb-item v-if='flowId!=null'>编辑作业</a-breadcrumb-item>
			</a-breadcrumb>
		</div>
		<div class="page-content">
			<div class="message-top"></div>
			<div class="add-content">
				<div class="base-info">
					<div class="title">
						<img src="@/assets/image/homeImg/icon_js.png" alt="">
						<span>基本参数</span>
						<!-- <span>
						  <i class="iconfont icon-shouqi" v-show='!isShowBase' @click='showBase()'></i>
						   <i class="iconfont  icon-zhankai1" v-show='isShowBase' @click='showBase()'></i>
						</span> -->
					</div>
					<div class="base-info-content" v-show='!isShowBase'>
						<a-row>
							<a-col :span="10">
								<span class="key">作业名称：</span>
								<span v-if='tqData' class="value">{{tqData.jobsName}}</span>
							</a-col>
							<a-col :span="10">
								<span style="display:inline-block;width:100px"
								      class="key hospital-required">流程名称：</span>
								<span class="value" style="display:inline-block;width:300px">
                  <a-select style="width:100%" v-model='recordValue' @change="handleChange">
                    <a-select-option v-for="(item,index) in processListData" :key='index' :value="item.moduleId">{{item.name}}</a-select-option>
                 
                  </a-select>
                </span>
							</a-col>
						</a-row>

						<a-row>
							<a-col :span="24">
								<span class="key">FQ文件：</span>
								<span class="value">
                  <div v-for="(item,index) in fqData" :key='index'>
                    <span>{{item.fileName}}</span>
	                  <!-- <a-checkbox >{{item.fileName}}</a-checkbox> -->
                  </div>
                
                </span>
							</a-col>
						</a-row>
					</div>
				</div>
				<div class="flow-info">
					<div class="title">
						<img src="@/assets/image/homeImg/icon_lc.png" alt="">
						<span>流程参数</span>
						<span>
              <i class="iconfont icon-shouqi" @click='showFlow()' v-show='!isShowFlow'></i>
               <i class="iconfont icon-zhankai1" v-show='isShowFlow' @click='showFlow()'></i>
            </span>
					</div>
					<div class="flow-info-table" v-show='!isShowFlow'>
						<a-table
								class="hospital-table"
								:pagination="false"
								:locale="{emptyText:'暂无数据'}"
								:columns="columns"
								:dataSource="data"
								:rowKey="record => record.tag"
								size="middle"
						>
							<div slot-scope="text,record" style="padding-left:80px" slot="tag">
								{{record.tag?record.tag:'暂无'}}
							</div>
						</a-table>
					</div>
				</div>
				<div class="flow-info">
					<div class="title">
						<img src="@/assets/image/homeImg/icon_zy.png" alt="">
						<span>资源信息</span>
						<span>
              <i class="iconfont icon-shouqi" v-show='!isShowInfo' @click='showInfo()'></i>
               <i class="iconfont icon-zhankai1" v-show='isShowInfo' @click='showInfo()'></i>
            </span>
					</div>
					<div class="flow-info-table" v-show='!isShowInfo'>
						<a-table
								class="hospital-table"
								:pagination="false"
								:locale="{emptyText:'暂无数据'}"
								:columns="resourceColumns"
								:rowKey="record => record.id"
								:dataSource="resourcedata"
								size="middle"
						>
							<div slot-scope="text" style="padding-left:80px" slot="itemName">{{text}}</div>
							<template slot-scope="text,record" v-if='record.itemName' slot="jsonpObject1">
								<span v-if='record.jsonpObject'>{{record.jsonpObject[record.itemName+'_cpu']}}</span>
							</template>
							<template slot="jsonpObject2" slot-scope="text,record">
								<span v-if='record.jsonpObject'>{{record.jsonpObject[record.itemName+'_memory']}}</span>
							</template>
							<template slot="jsonpObject3" slot-scope="text,record">
								<span v-if='record.jsonpObject'>{{record.jsonpObject[record.itemName+'_disk']}}</span>
							</template>
						</a-table>
					</div>
				</div>
				<div class="footer">
					<a-button
							v-auth="'105042'"
							style="width:680px"
							:disabled='detail.jobsStatus=="running"'
							:loading="isHttpSubmit"
							@click="submit()"
							type="primary"
					>提交执行
					</a-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  export default {
    data() {
      return {
        isShowBase: false, //显示基本信息
        isShowFlow: true, //显示流程参数
        isShowInfo: true, //显示资源信息
        id: this.$route.query.id,
        bid: this.$route.query.bid,
        flowId: this.$route.query.flowId ? this.$route.query.flowId : null,
        isHttpSubmit: false,
        recordValue: '',
        isClick: true,
        detail: {},
        processListData: [],
        fqData: [],
        tqData: null,
        resourceColumns: [
          {
            title: "参数名称",
            dataIndex: "itemName",
            scopedSlots: {customRender: "itemName"}
          },
          {
            title: "CPU个数",
            // dataIndex:'resource',
            scopedSlots: {customRender: "jsonpObject1"}
          },
          {
            title: "内存（MB）",
            // dataIndex:'resource',
            scopedSlots: {customRender: "jsonpObject2"}
          },
          {
            title: "磁盘（MB）",
            dataIndex: 'jsonpObject',
            scopedSlots: {customRender: "jsonpObject3"}
          }
        ],
        resourcedata: [
          {
            name: "READSCLEAN2_92178:",
            cpu: 8,
            cmb: 1,
            mmb: 2
          }
        ],
        columns: [
          {
            title: "参数名称",
            // dataIndex: "tag",
            scopedSlots: {customRender: "tag"}
          },
          {
            title: "参数值",
            dataIndex: "defaultValue",
            customRender: (text, record, index) => {
              if (record.defaultValue) {
                return record.defaultValue
              } else {
                return '暂无'
              }
            }
          }
        ],
        data: [
          {
            name: 2,
            value: "xtao@xtao:iwand/uec0401/jobs/08fd60a2c06545f4bab8ab64e4bf6058"
          }
        ]
      };
    },
    methods: {
      getDetail() {
        let _this = this
        this.$get("/jobsmanage/jobs/detail/" + this.id).then(res => {
          this.detail = res.data.data;
        })
      },
      // 编辑作业 执行作业
      submit() {
        if (this.isClick) {
          this.isClick = false;
          if (this.flowId) {
            this.$post('/cloudPlatformApi/editAndExecutePlatformJobs', {
              localJobsId: this.id,
              pipelineId: this.recordValue
            }).then(res => {
              if (res.data.code == 1) {
                this.isClick = true;
                this.$message.success(res.data.message);
                this.$router.push({path: "/job/details", query: {id: res.data.data.localJobId}});
              } else {
                this.isClick = true;
                this.$message.error(res.data.message);
              }

            }).catch(err => {
              this.isClick = true;
              this.$message.error(err.data.message);
            })
          } else {
            this.$post('/cloudPlatformApi/createPlatformJobs', {
              localJobsId: this.id,
              pipelineId: this.recordValue
            }).then(res => {
              if (res.data.code == 1) {
                this.isClick = true;
                this.$message.success(res.data.message);
                this.$router.push({path: "/job/details", query: {id: this.id}});
              } else {
                this.isClick = true;
                this.$message.error(res.data.message);
              }
            }).catch(err => {
              this.isClick = true;
              this.$message.error(err.data.message);
            })
          }
        }
      },
      // GET /api/jobsmanage/jobs/detail/{id}
      getData() {
        this.$get('/jobsmanage/jobs/detail/' + this.id).then(res => {
          this.tqData = res.data.data
        })
      },
      handleChange(value) {
        this.getCloudPlatformParamList(value)
        this.getCloudPlatformResourceList(value)
      },
      // GET /api/cloudPlatformApi/getCloudPlatformParamList
      //获取云平台参数
      getCloudPlatformParamList(id) {
        this.$get('/cloudPlatformApi/getCloudPlatformParamList', {
          cloudPlatformProcessId: id
        }).then(res => {
          this.data = res.data.data
        })
      },
      // GET /api/cloudPlatformApi/getCloudPlatformJobDetail
      getCloudPlatformJobDetail(id) {
        this.$get('/cloudPlatformApi/getCloudPlatformJobDetail', {
          cloudPlatformJobId: id
        }).then(res => {

        })
      },
      // /api/cloudPlatformApi/getCloudPlatformProcessList
      // 获取流程列表
      getCloudPlatformProcessList() {
        this.$get('/cloudPlatformApi/getCloudPlatformProcessList').then(res => {
          this.processListData = res.data.data.records
          if (this.flowId) {
            this.recordValue = this.flowId
          } else {
            this.recordValue = this.processListData[0].moduleId
          }

          this.getCloudPlatformParamList(this.recordValue)
          this.getCloudPlatformResourceList(this.recordValue)
        })


      },
      //GET /api/cloudPlatformApi/getCloudPlatformResourceList
      //获取云平台资源
      getCloudPlatformResourceList(id) {
        this.$get('/cloudPlatformApi/getCloudPlatformResourceList', {
          cloudPlatformProcessId: id
        }).then(res => {
          this.resourcedata = res.data.data;
        })
      },
      // GET /api/uploadfq/uploadFq/getFqList
      getJobName() {
        let data = {
          bid: this.bid
        }
        this.$get('/uploadfq/uploadFq/getFqList', {
          bid: this.bid
        }).then(res => {
          this.fqData = res.data.data
        })
      },
      showBase() {
        this.isShowBase = !this.isShowBase
      },
      showFlow() {
        this.isShowFlow = !this.isShowFlow
      },
      showInfo() {
        this.isShowInfo = !this.isShowInfo
      }
    },
    created() {
      this.getData()
      this.getJobName()
      this.getDetail()
      this.getCloudPlatformProcessList()
    }
  };
</script>

<style lang="scss" scoped>
	.job-add {
		width: 100%;
		min-width: 1200px;
		.breadcrumb {
			padding: 0 40px;
			height: 46px;
			line-height: 46px;
			background: #f8fbfb;
			/deep/ .ant-breadcrumb {
				display: inline-block;
			}
		}
		.page-content {
			padding: 0 40px;
			background: #fff;
			display: inline-block;
			width: 100%;
			.message-top {
				padding: 25px 0 20px 0;
				font-size: 12px;
				font-family: PingFang SC;
				font-weight: 400;
				color: rgba(195, 195, 195, 1);
			}
			.add-content {
				width: 100%;
				background: rgba(255, 255, 255, 1);
				border: 1px solid rgba(240, 242, 245, 1);
				margin-bottom: 100px;
				.base-info {
					padding: 26px 32px;
					border-bottom: 1px solid rgba(240, 242, 245, 1);
					.title {
						display: flex;
						justify-content: flex-start;
						align-items: flex-start;
						font-size: 16px;
						font-family: PingFang SC;
						font-weight: 400;
						margin-bottom: 15px;
						color: rgba(51, 51, 51, 1);
						cursor: pointer;
						span:nth-child(2) {
							margin: 0 5px;
						}
					}
					/deep/ .base-info-content {
						.ant-col-10,
						.ant-col-24 {
							padding-left: 30px;
							margin-top: 20px;
							.key {
								font-size: 13px;
								width: 90px;
								display: block;
								line-height: 32px;
								float: left;
								font-family: PingFang SC;
								font-weight: 400;
								color: rgba(22, 34, 50, 1);
							}
							.value {
								font-size: 13px;
								display: inline-block;
								line-height: 32px;
								width: calc(100% - 90px);
								font-family: PingFang SC;
								font-weight: 400;
								color: rgba(22, 34, 50, 1);
							}
						}
					}
				}
				/deep/ .flow-info {
					padding: 26px 32px;
					border-bottom: 1px solid rgba(240, 242, 245, 1);
					.title {
						display: flex;
						justify-content: flex-start;
						align-items: flex-start;
						font-size: 16px;
						font-family: PingFang SC;
						font-weight: 400;
						margin-bottom: 15px;
						cursor: pointer;
						color: rgba(51, 51, 51, 1);
						span:nth-child(2) {
							margin: 0 5px;
						}
					}
					.ant-table-thead th[key="name"] {
						padding-left: 80px !important;
					}
				}
				.footer {
					text-align: center;
					padding: 40px 0;
				}
			}
		}
	}
</style>